/*eslint-disable */
<template>
  <b-col md="12 m-0 p-0">
    <b-card no-body>
      <b-card-text class="p-0 mt-1 pull-left">
        <div class="mb-2">
          <b-badge class="mr-2"  v-for="item in payTransactionsList" :key="item.id" variant="purple">
            {{ item.gide_product_name }}
          </b-badge>
        </div>
      </b-card-text>
    </b-card>
  </b-col>
</template>

<script>
import { PayTransactionss } from "../FackApi/api/PayTransactions.js"

export default {
  name: "PlanDetail",
  props: {
    propStudentData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      cvCardTitle: "Subscribed Products",
      payTransactionsList: []
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  watch: {
    "propStudentData.user_id": {
      immediate: true,
      async handler (userId) {
        if (userId) {
          await this.getpayTransactionsList()
        }
      }
    }
  },
  async mounted () {
    this.getpayTransactionsList()
  },
  methods: {
    /**
     * unique Subscribed products
     */
    getUniqueSubscribedProducts (payTransactionsList) {
      const seen = new Set()
      const uniquePlans = payTransactionsList.filter(item => {
        if (seen.has(item.gide_product_name)) {
          return false
        }
        seen.add(item.gide_product_name)
        return true
      })
      return uniquePlans
    },
    /**
     * getpayTransactionsList
     */
    async getpayTransactionsList () {
      try {
        const userId = this.propStudentData?.user_id
        if (!userId) {
          return
        }

        let payTransactionsListResp = await PayTransactionss.payUserTransactionsList(this, userId)
        if (payTransactionsListResp.resp_status) {
          this.payTransactionsList = this.getUniqueSubscribedProducts(payTransactionsListResp.resp_data.data)
        }
        else {
          this.toastMsg = payTransactionsListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at getpayTransactionsList() and Exception:", err.message)
      }
    }
  }
}
</script>

<style>
.active_interest {
  background-color: #51B5FD !important;
  border-color: #51B5FD !important;
}
.active_interest span {
  color: #FFFFFF !important;
}
.textSpan {
  color: var(--iq-body-text);
  text-transform: capitalize;
  font-size: 15px;
  margin-left: 13px;
}
</style>
